module.exports = __webpack_public_path__ + "assets/img/year-light2.3307f157.png";